import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Alert,
  Paper,
  Divider,
  Button,
  TextField,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Checkbox,
  FormControl,
  // FormLabel,
  RadioGroup,
  // FormControlLabel,
  Radio,
  ButtonBase,
  // FormControlLabel,
} from "@mui/material";
import { useParams } from "react-router-dom";
import { Grid } from "@mui/material";
import regionsData from "@/app/features/company/data/regions_lite.json";
import citiesData from "@/app/features/company/data/cities_lite.json";
import PrintIcon from "@mui/icons-material/Print";
import { FileUploader } from "react-drag-drop-files";
import { useSelector } from "react-redux";
import { RootState } from "@/store/type";
import { isUndefined } from "lodash";
import DeleteIcon from "@mui/icons-material/Delete";
import { UploadFile } from "@mui/icons-material";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import useTransform from "@/app/features/Transformation/hook/use-transform";
import SendOrderSubmitView from "@/pages/order/components/view/confirm.order.submit.view";
import ConfirmOrderSubmitView from "@/pages/order/components/view/send.order.submit.view";
import ReceivedOrderSubmitView from "@/pages/order/components/view/received.order.submit.view";
import SaveOrderSubmitView from "@/pages/order/components/view/save.order.submit.view";
import { LANG, ROLE } from "@/types";
import useOrder from "@/hooks/use-order";
import { generatePDFOrder } from "@/service/generatepdforder";

interface Product {
  itemId: string;
  item: string;
  quantity: number;
  price: number;
  discount: number;
  notice: string;
  image: string;
  attachment: string;
  company: {
    nameAr: string;
    CompanyNr: string;
  };
}
interface Invoice {
  fileName: string;
  companyId: string;
  createdDate: string;
  userId: string;
  enVersion: string;
  arVersion: string;
}
interface Transformation {
  id: string;
  title: string;
  status: "Pending" | "Accepted" | "Refused";
  buyerId: string;
  sellerId: string;
  userId: string;
  orderId: string;
  totalPrice: number;
  transformRequest: boolean;
  withdrawRequest: boolean;
  createdAt: Date;
}
interface Company {
  id: string;
  nameAr: string;
  nameEn: string;
  address: string;
  region: string;
  city: string;
  contactInfo: string;
  CompanyNr: string;
}

interface Tender {
  id: string;
  title: string;
  minValue: number;
  value: number;
  endDate: string;
  deliverDate: string;
  type: string;
}

interface Order {
  id: string;
  title: string;
  deliverDate: string;
  city: string;
  address: string;
  products: Product[];
  Sendedproducts: Product[];
  OrderNr: number;
  company: Company;
  Buycompany: Company;
  Tender: Tender;
  status: string;
  DeliveryMethod: string;
  paymentMethod: string;
  invoices: Invoice[];
}
interface City {
  city_id: number;
  region_id: number;
  name_ar: string;
}
interface Region {
  region_id: number;
  name_ar: string;
}
interface Option {
  value: string;
  label: string;
}
const OrderPage: React.FC = () => {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  const { id } = useParams<{ id: string }>();

  const {
    fetchOrderById,
    updateOrder: updateOrderApi,
    isOrderLoading,
    loading,
    error,
  } = useOrder();
  const { upsertTransform, fetchTransforms } = useTransform();
  const [order, setOrder] = useState<Order | null>(null);
  const [regions, setRegions] = useState<Option[]>([]);
  const [cities, setCities] = useState<Option[]>([]);
  // const [isConfirmPopupOpen, setIsConfirmPopupOpen] = useState(false);
  const [isConfirmReceivedPopupOpen, setIsConfirmReceivedPopupOpen] =
    useState(false);
  // const [confirmAction, setConfirmAction] = useState<
  //   "accept" | "cancel" | null
  // >(null);
  const [sendedItems, setSendedItems] = useState<Product[]>([]);
  const authUser = useSelector((state: RootState) => state.auth.authUser);
  const userRole = isUndefined(authUser?.role) ? "" : authUser?.role;
  const myCompany = useSelector((state: RootState) => state.auth.myCompany);
  const [isTransformationPopupOpen, setIsTransformationPopupOpen] =
    useState(false);
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const [isSendingOrder, setIsSendingOrder] = useState(false);
  const [AvailableCount, setAvailableCount] = useState(0);
  const [customShipment, setCustomShipment] = useState("");
  const [ShowcustomShipment, setShowCustomShipment] = useState(false);
  const bankInfo = {
    accountName: "شركة ميدا المتقدمة لحلول الاعمال",
    accountNumber: "212000010006086127973",
    iban: "SA0780000212608016127973",
    bankName: "بنك الراجحي",
  };
  const paymentMethods = [
    {
      value: 2,
      icon: (
        <img
          src="/icons/visa.png"
          alt="Visa"
          style={{ width: 60, height: "auto" }}
        />
      ),
      label: "Visa",
      disabled: true,
    },
    {
      value: 3,
      icon: (
        <img
          src="/icons/mastercard.png"
          alt="MasterCard"
          style={{ width: 60, height: "auto" }}
        />
      ),
      label: "MasterCard",
      disabled: true,
    },
    {
      value: 1,
      icon: <AccountBalanceIcon sx={{ color: "#1976d2", fontSize: 30 }} />,
      label: "تحويل بنكي",
      disabled: false,
    },
    {
      value: 0,
      icon: (
        <AccountBalanceWalletIcon sx={{ color: "#1976d2", fontSize: 30 }} />
      ),
      label: t("navigation.Wallet"),
      disabled: true,
    },
  ];
  useEffect(() => {
    setRegions(
      regionsData.map((region: Region) => ({
        value: region.region_id.toString(),
        label: region.name_ar,
      }))
    );
  }, []);
  useEffect(() => {
    const loadItems = async () => {
      try {
        const response = await fetchTransforms({
          buyerId: myCompany.id,
          pageSize: 10,
          pageNumber: 0,
          withPaging: false,
        });
        const transforms = response?.data || [];
        const total = transforms.reduce(
          (sum: number, t: Transformation) => sum + t.totalPrice,
          0
        );
        const pending = transforms
          .filter((t: Transformation) => t.status === "Pending")
          .reduce((sum: number, t: Transformation) => sum + t.totalPrice, 0);
        const transformed = transforms
          .filter((t: Transformation) => t.withdrawRequest)
          .reduce((sum: number, t: Transformation) => sum + t.totalPrice, 0);

        setAvailableCount(total - pending - transformed);
      } catch (error) {
        console.error("Error fetching transformations:", error);
      }
    };
    loadItems();
  }, [myCompany]);
  useEffect(() => {
    setCities(
      citiesData.map((City: City) => ({
        value: City.city_id.toString(),
        label: City.name_ar,
      }))
    );
  }, []);
  const getCity = (value: string) => {
    let city = cities.find((item) => parseInt(item.value) === parseInt(value));
    if (city) {
      return city.label;
    } else {
      return "";
    }
  };
  const getRegion = (value: string) => {
    let city = regions.find((item) => parseInt(item.value) === parseInt(value));
    if (city) {
      return city.label;
    } else {
      return "";
    }
  };
  useEffect(() => {
    const fetchOrder = async () => {
      try {
        if (id) {
          const result = await fetchOrderById(id);
          setOrder(result.data);
          setSendedItems([]);
        }
      } catch (err) {
        console.error("Error fetching order:", err);
      }
    };
    fetchOrder();
  }, [id]);

  const calculateTotalPrice = (products: Product[]) =>
    products.reduce(
      (sum, product) => sum + product.price * product.quantity,
      0
    );

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }
  const handleQuantitySChange = (product: Product, newQuantity: number) => {
    setSendedItems((prev) =>
      prev.map((item) =>
        item === product ? { ...item, quantity: newQuantity } : item
      )
    );
  };
  const handleQuantityChange = (itemId: string, newQuantity: number) => {
    if (!order) return;
    const updatedProducts = order.products.map((product) =>
      product.itemId === itemId
        ? { ...product, quantity: newQuantity }
        : product
    );
    setOrder({ ...order, products: updatedProducts });
  };
  const handleDeleteProduct = (itemId: string) => {
    if (!order) return;
    const updatedProducts = order.products.filter(
      (product) => product.itemId !== itemId
    );
    setOrder({ ...order, products: updatedProducts });
  };

  const handleSaveOrder = async () => {
    if (!order) return;
    const { Tender, company, Buycompany, ...updateOrder } = order;
    try {
      await updateOrderApi(updateOrder).then(async () => {
        const result = await fetchOrderById(order.id);
        setOrder(result.data);
      });

      alert(t("alerts.success.orderSaved"));
    } catch (error) {
      console.error("Error updating order:", error);
    }
  };

  const handleSendOrder = async () => {
    setIsTransformationPopupOpen(true);
  };
  const handleConfirmReceived = async () => {
    if (!order) return;

    try {
      const { Tender, company, Buycompany, ...updateOrder } = order;
      const updatedOrder = { ...updateOrder, status: "Receiving" };

      await updateOrderApi(updatedOrder).then(async () => {
        const result = await fetchOrderById(order.id);
        setOrder(result.data);
      });

      setIsConfirmReceivedPopupOpen(false);
      alert(t("alerts.success.orderConfirmed"));
    } catch (error) {
      console.error("Error confirming received order:", error);
    }
  };
  const handleConfirmAccept = async () => {
    if (!order) return;
    const { Tender, company, Buycompany, ...updateOrder } = order;
    try {
      const updatedOrder = { ...updateOrder, status: "Accepted" };
      await updateOrderApi(updatedOrder).then(async () => {
        const result = await fetchOrderById(order.id);
        setOrder(result.data);
      });
      alert(t("alerts.success.orderAccepted"));
    } catch (error) {
      console.error("Error updating order:", error);
    }
  };
  const handleConfirmCancel = async () => {
    if (!order) return;
    const { Tender, company, Buycompany, ...updateOrder } = order;
    try {
      const updatedOrder = { ...updateOrder, status: "Canceled" };
      await updateOrderApi(updatedOrder).then(async () => {
        const result = await fetchOrderById(order.id);
        setOrder(result.data);
      });
      alert(t("alerts.success.orderCanceled"));
    } catch (error) {
      console.error("Error updating order:", error);
    }
  };
  if (error) {
    return (
      <Alert severity="error" sx={{ mt: 4 }}>
        {t("alerts.error.fetchOrderDetails")}
      </Alert>
    );
  }

  if (!order) {
    return (
      <Typography variant="h6" align="center" sx={{ mt: 4 }}>
        {t("alerts.error.noOrderDetails")}
      </Typography>
    );
  }
  const handlePrint = (order: Order) => {
    generatePDFOrder({
      ...order,
      city: getCity(order.city),
      Buycompany: {
        ...order.Buycompany,
        region: order.Buycompany
          ? getRegion(order.Buycompany.region || "")
          : "",
        city: order.Buycompany ? getCity(order.Buycompany.city || "") : "",
        id: order.Buycompany ? order.Buycompany.id || "" : "",
        nameAr: order.Buycompany ? order.Buycompany.nameAr || "" : "",
        nameEn: order.Buycompany ? order.Buycompany.nameEn || "" : "",
        CompanyNr: order.Buycompany ? order.Buycompany.CompanyNr || "" : "",
      },
      company: {
        ...order.company,
        region: order.company ? getRegion(order.company.region || "") : "",
        city: order.company ? getCity(order.company.city || "") : "",
        id: order.company ? order.company.id || "" : "",
        nameAr: order.company ? order.company.nameAr || "" : "",
        nameEn: order.company ? order.company.nameEn || "" : "",
        CompanyNr: order.company.CompanyNr,
      },
    });
  };
  const statuses = [
    { label: t("status.planning"), name: "Planning", total: 0 },
    { label: t("general.purchaseRequest"), name: "Opened", total: 0 },
    { label: t("status.accepted"), name: "Accepted", total: 0 },
    { label: t("status.shipping"), name: "Sending", total: 0 },
    { label: t("status.received"), name: "Receiving", total: 0 },
    { label: t("status.completed"), name: "Finished", total: 0 },
    { label: t("general.reviewRequest"), name: "Revision", total: 0 },
    { label: t("status.rejected"), name: "Canceled", total: 0 },
  ];

  const getStatusLabel = (status: string) => {
    const statusItem = statuses.find((s) => s.name === status);
    return statusItem ? statusItem.label : t("status.unknown");
  };
  const handleAddToSended = (product: Product) => {
    if (!order) return;
    setSendedItems((prev) => [...prev, { ...product, quantity: 1 }]);
  };
  const handleRemoveFromSended = (product: Product) => {
    setSendedItems((prev) =>
      prev.filter(
        (item) =>
          item !== product || order?.Sendedproducts.some((p) => p === product)
      )
    );
  };
  const isFetchedSendedProduct = (product: Product) =>
    order?.Sendedproducts.some((item) => item === product);

  const handleSaveSendedItems = async () => {
    if (!order) return;
    const { Tender, company, Buycompany, ...updateOrder } = order;
    try {
      const updatedOrder = {
        ...updateOrder,
        Sendedproducts:
          sendedItems.length > 0
            ? [...updateOrder.Sendedproducts, ...sendedItems]
            : updateOrder.Sendedproducts,
      };
      await updateOrderApi(updatedOrder).then(async () => {
        const result = await fetchOrderById(order.id);
        setOrder(result.data);
        setSendedItems([]);
      });
      alert(t("alerts.success.productsSaved"));
    } catch (error) {
      console.error("Error saving sent items:", error);
    }
  };
  const handleFileUpload = (file: File) => {
    setUploadedFile(file);
  };

  const handleSendOrderWithTransformation = async () => {
    if (!order || !uploadedFile) return;

    try {
      setIsSendingOrder(true);
      const transformationPayload = {
        orderId: order.id,
        totalPrice:
          parseInt(order.paymentMethod) === 0
            ? -calculateTotalPrice(order.products)
            : calculateTotalPrice(order.products),
        attachment: uploadedFile,
        title: `Transformation for Order ${order.id}`,
        status: parseInt(order.paymentMethod) === 0 ? "Accept" : "Pending",
        buyerId: order.Buycompany.id,
        sellerId: order.company.id,
        products: JSON.stringify(order.products),
        transformRequest: false,
        type: "OrderTransfrom",
      };

      const transformResponse = await upsertTransform(transformationPayload);

      if (transformResponse?.isSuccess) {
        const { Tender, company, Buycompany, ...updateOrder } = order;
        const orderPayload = {
          ...updateOrder,
          status: "Opened",
        };

        const orderResponse = await updateOrderApi(orderPayload);

        if (orderResponse?.isSuccess) {
          Swal.fire({
            icon: "success",
            title: t("alerts.success.orderReceived"),
            html: `
              <p>${t("alerts.info.orderNumber")} <strong>#${
              order.OrderNr
            }</strong></p>
              <p>${t(
                "alerts.info.invoiceDetails"
              )} <a target="_blank" style="color: #1976d2; text-decoration: underline;">${t(
              "alerts.info.purchaseInvoice"
            )}</a></p>
            `,
            showConfirmButton: true,
            confirmButtonText: t("actions.accept"),
          });
          setIsTransformationPopupOpen(false);
        } else {
          alert(t("alerts.error.sendOrderFailed"));
        }
      } else {
        alert(t("alerts.error.transformationFailed"));
      }
    } catch (error) {
      console.error("Error sending order with transformation:", error);
      alert(t("alerts.error.ErrorhandlingOrder"));
    } finally {
      setIsSendingOrder(false);
    }
  };
  const handleShipmentChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newShipment = event.target.value;
    if (newShipment === "Other") {
      setShowCustomShipment(true);
      setCustomShipment(""); // Reset field
    } else {
      setShowCustomShipment(false);
      setOrder((prevOrder) =>
        prevOrder
          ? {
              ...prevOrder,
              DeliveryMethod: newShipment,
            }
          : prevOrder
      );
    }
  };

  const handleCustomShipmentChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const newCustomShipment = event.target.value;
    setCustomShipment(newCustomShipment);

    // Update order's delivery method with the custom input
    setOrder((prevOrder: any) => ({
      ...prevOrder,
      DeliveryMethod: newCustomShipment,
    }));
  };
  const handlePaymentMethodChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const paymentMethod = event.target.value;
    setOrder((prevOrder: any) => ({
      ...prevOrder,
      paymentMethod: paymentMethod,
    }));
  };
  const predefinedMethods = ["FedEx", "DHL Express", "SPL", "Aramex"];
  const isOtherSelected =
    !predefinedMethods.includes(order.DeliveryMethod) &&
    order.DeliveryMethod !== "";
  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: "bold", mb: 1 }}>
        {t("orders.details")}
      </Typography>
      <div className="flex gap-4  mb-4" style={{ maxWidth: 100 }}>
        <Button
          className="flex items-center bg-secondary-brightYellow shadow text-textcolor-black w-full py-1 px-3 text-sm"
          style={{ background: "#000", color: "#fff", visibility: "hidden" }}
          onClick={() => handlePrint(order)}
        >
          <PrintIcon />
        </Button>
      </div>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={6}>
          <Paper sx={{ p: 3, mb: 1 }} elevation={0}>
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
              {t("orders.infos")}
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" sx={{ mb: 1 }}>
              <strong>{t("orders.number")}:</strong> {order.OrderNr}
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              <strong>{t("orders.title1")}:</strong> {order.title}
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              <strong>{t("orders.fields.status")}:</strong>{" "}
              {getStatusLabel(order.status)}
            </Typography>

            <Typography variant="body1" sx={{ mb: 1 }}>
              <strong>{t("orders.fields.deliveryDate")}:</strong>{" "}
              {new Date(order.deliverDate).toLocaleDateString()}
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              <strong>{t("orders.fields.totalPrice")}:</strong>{" "}
              {calculateTotalPrice(order.products).toFixed(2)}{" "}
              {t("checkout.summary.currency")}
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Paper sx={{ p: 3, mb: 1 }} elevation={0}>
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
              {t("orders.buyerCompanyDetails")}
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" sx={{ mb: 1 }}>
              <strong>{t("company.fields.CompanyNr")}:</strong>{" "}
              {order.Buycompany.CompanyNr}
            </Typography>

            <Typography variant="body1" sx={{ mb: 1 }}>
              <strong>{t("company.fields.region")}:</strong>{" "}
              {getRegion(order.Buycompany.region)}
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              <strong>{t("company.fields.city")}:</strong>{" "}
              {getCity(order.Buycompany.city)}
            </Typography>
            {/* <Typography variant="body1" sx={{ mb: 1 }}>
              <strong>{t("company.fields.contactEmail")}:</strong>{" "}
              {order.Buycompany.contactInfo}
            </Typography> */}
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Paper sx={{ p: 3, mb: 1 }} elevation={0}>
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
              {t("tenders.details")}
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" sx={{ mb: 1 }}>
              <strong>{t("tenders.name")}:</strong> {order.Tender.title}
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              <strong>{t("tender.value")}:</strong> {order.Tender.value}{" "}
              {t("checkout.summary.currency")}
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              <strong>{t("tenders.endDate")}:</strong>{" "}
              {new Date(order.Tender.endDate).toLocaleDateString()}
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Paper sx={{ p: 3, mb: 1 }} elevation={0}>
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
              {t("delivery.shipmentDetails")}
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <FormControl component="fieldset">
              {/* <FormLabel component="legend">
                {t("delivery.selectCompany")}
              </FormLabel> */}
              <RadioGroup
                aria-label="shipment-method"
                value={isOtherSelected ? "Other" : order.DeliveryMethod}
                onChange={handleShipmentChange}
                sx={{ mt: 2 }}
              >
                {/*
                <FormControlLabel
                  value="FedEx"
                  control={<Radio />}
                  label="FedEx"
                />
                <FormControlLabel
                  value="DHL Express"
                  control={<Radio />}
                  label="DHL Express"
                />
                <FormControlLabel
                  value="SPL"
                  control={<Radio />}
                  label="سُبل"
                />
                <FormControlLabel
                  value="Aramex"
                  control={<Radio />}
                  label="Aramex"
                />
                */}
                {/* <FormControlLabel
                  value={"Other"}
                  control={<Radio />}
                  label={t("delivery.other")}
                /> */}
              </RadioGroup>
              {ShowcustomShipment === true && (
                <div style={{ display: "flex" }}>
                  <Typography variant="body1" sx={{ mb: 0 }}>
                    {t("delivery.otherCompany")}
                  </Typography>
                  <TextField
                    label=""
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={customShipment}
                    onChange={handleCustomShipmentChange}
                    sx={{ mt: 2 }}
                  />
                </div>
              )}
            </FormControl>
            <Typography variant="body1" sx={{ mb: 0 }}>
              <strong>{t("delivery.shippingCompany")}:</strong>{" "}
              {order.DeliveryMethod}
            </Typography>
            {/* <Typography variant="body1" sx={{ mb: 1 }}>
              <strong>{t("company.fields.address")}:</strong>{" "}
              {order.address || "N/A"}
            </Typography> */}
            <Typography variant="body1" sx={{ mb: 1 }}>
              <strong>{t("delivery.shippingDate")}:</strong>{" "}
              {new Date(order.deliverDate).toLocaleDateString()}
            </Typography>
          </Paper>

          {userRole === ROLE.SELLER ? (
            ""
          ) : (
            <Paper sx={{ p: 3, mb: 1, borderRadius: 2 }} elevation={0}>
              <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
                {t("payment.details")}
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <Typography variant="body1" sx={{ mb: 1 }}>
                <strong>{t("payment.method")}:</strong>
              </Typography>
              <Box sx={{ mt: 2 }}>
                <RadioGroup
                  value={order.paymentMethod}
                  onChange={handlePaymentMethodChange}
                  row
                >
                  {paymentMethods.map((method) => (
                    <ButtonBase
                      key={method.value}
                      onClick={() =>
                        handlePaymentMethodChange({
                          target: { value: method.value.toString() },
                        } as React.ChangeEvent<HTMLInputElement>)
                      }
                      disabled={method.disabled}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                        border:
                          order.paymentMethod === method.value.toString()
                            ? "2px solid #1976d2"
                            : "1px solid #ddd",
                        borderRadius: 2,
                        padding: 2,
                        width: 100,
                        height: 100,
                        background: method.disabled ? "#E6e6e6" : "#fff",
                        margin: 1,
                        "&:hover": {
                          border: "2px solid #1976d2",
                          backgroundColor: "#f5f5f5",
                        },
                      }}
                    >
                      {method.icon}
                      <Radio value={method.value} sx={{ display: "none" }} />
                    </ButtonBase>
                  ))}
                </RadioGroup>
              </Box>
              <Divider sx={{ my: 2 }} />
              <Box>
                {parseInt(order.paymentMethod) === 2 && (
                  <Typography variant="body2" sx={{ mt: 2 }}>
                    {t("payment.visa")}
                  </Typography>
                )}
                {parseInt(order.paymentMethod) === 3 && (
                  <Typography variant="body2" sx={{ mt: 2 }}>
                    {t("payment.mastercard")}
                  </Typography>
                )}
                {parseInt(order.paymentMethod) === 1 && (
                  <Box sx={{ mt: 2 }}>
                    <Typography variant="body2">
                      <strong>{t("payment.bankTransfer")}:</strong>
                    </Typography>
                    <Typography variant="body2">
                      {t("payment.bankName")}: {bankInfo.bankName}
                    </Typography>
                    <Typography variant="body2">
                      {t("item.fields.name")}: {bankInfo.accountName}
                    </Typography>
                    <Typography variant="body2">
                      {t("payment.accountNumber")}: {bankInfo.accountNumber}
                    </Typography>
                    <Typography variant="body2">
                      {t("payment.iban")}: {bankInfo.iban}
                    </Typography>
                  </Box>
                )}
                {parseInt(order.paymentMethod) === 0 && (
                  <Box sx={{ mt: 2 }}>
                    <Typography variant="body2">
                      <Grid container spacing={1}>
                        <Grid item xs={12} sm={6}>
                          <Paper sx={{ p: 3, mb: 1 }} elevation={0}>
                            <Typography
                              variant="h6"
                              sx={{ fontWeight: "bold", mb: 2 }}
                            >
                              {t("wallet.details")}
                            </Typography>
                            <Divider sx={{ mb: 2 }} />
                            <Typography variant="body1">
                              <strong>{t("wallet.currentBalance")}:</strong>{" "}
                              {AvailableCount.toFixed(2)}{" "}
                              {t("checkout.summary.currency")}
                            </Typography>
                          </Paper>
                        </Grid>
                      </Grid>
                    </Typography>
                  </Box>
                )}
              </Box>
            </Paper>
          )}
        </Grid>
        <Grid item xs={12} sm={12}>
          <Paper sx={{ p: 3, mb: 1 }} elevation={0}>
            <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2 }}>
              {t("products.title")}
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    {userRole === ROLE.SELLER &&
                      order.status === "Accepted" && (
                        <TableCell
                          align={locale === LANG.EN ? "left" : "right"}
                        ></TableCell>
                      )}
                    <TableCell
                      className="!font-bold !text-base"
                      align={locale === LANG.EN ? "left" : "right"}
                    ></TableCell>
                    <TableCell
                      className="!font-bold !text-base"
                      align={locale === LANG.EN ? "left" : "right"}
                    >
                      {t("products.name")}
                    </TableCell>
                    <TableCell
                      className="!font-bold !text-base"
                      align={locale === LANG.EN ? "left" : "right"}
                    >
                      {t("orders.fields.supplier")}
                    </TableCell>
                    <TableCell
                      className="!font-bold !text-base"
                      align={locale === LANG.EN ? "left" : "right"}
                    >
                      {t("checkout.fields.quantity")}
                    </TableCell>
                    <TableCell
                      className="!font-bold !text-base"
                      align={locale === LANG.EN ? "left" : "right"}
                    >
                      {t("item.fields.price")}
                    </TableCell>
                    <TableCell
                      className="!font-bold !text-base"
                      align={locale === LANG.EN ? "left" : "right"}
                    >
                      {t("orders.fields.discount")}
                    </TableCell>
                    <TableCell
                      className="!font-bold !text-base"
                      align={locale === LANG.EN ? "left" : "right"}
                    >
                      {t("orders.fields.notes")}
                    </TableCell>
                    {order.status === "Planning" && userRole === ROLE.BUYER && (
                      <TableCell
                        className="!font-bold !text-base"
                        align="right"
                      ></TableCell>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {order.products.map((product) => (
                    <TableRow key={product.itemId}>
                      {userRole === ROLE.SELLER &&
                        order.status === "Accepted" && (
                          <Checkbox
                            checked={sendedItems.some(
                              (item) => item === product
                            )}
                            onChange={(e) =>
                              e.target.checked
                                ? handleAddToSended(product)
                                : handleRemoveFromSended(product)
                            }
                          />
                        )}
                      <TableCell
                        className="min-w-24"
                        align={locale === LANG.EN ? "left" : "right"}
                      >
                        {product.image ? (
                          <img
                            src={product.image}
                            alt="item"
                            style={{
                              width: 70,
                              height: 70,
                              border: "1px solid #ccc",
                              borderRadius: 15,
                            }}
                          />
                        ) : (
                          "—"
                        )}
                      </TableCell>
                      <TableCell align={locale === LANG.EN ? "left" : "right"}>
                        {product.item}
                      </TableCell>
                      <TableCell align={locale === LANG.EN ? "left" : "right"}>
                        {product.company?.CompanyNr}
                      </TableCell>
                      <TableCell align={locale === LANG.EN ? "left" : "right"}>
                        {order.status === "Planning" &&
                        userRole === ROLE.BUYER ? (
                          <TextField
                            type="number"
                            value={product.quantity}
                            onChange={(e) =>
                              handleQuantityChange(
                                product.itemId,
                                parseInt(e.target.value, 10)
                              )
                            }
                            size="small"
                          />
                        ) : (
                          product.quantity
                        )}
                      </TableCell>
                      <TableCell align={locale === LANG.EN ? "left" : "right"}>
                        {product.price} {t("checkout.summary.currency")}
                      </TableCell>
                      <TableCell align={locale === LANG.EN ? "left" : "right"}>
                        {product.discount} {t("checkout.summary.currency")}
                      </TableCell>
                      <TableCell align={locale === LANG.EN ? "left" : "right"}>
                        {product.notice || t("orders.fields.noNotes")}
                      </TableCell>
                      <TableCell align={locale === LANG.EN ? "left" : "right"}>
                        {order.status === "Planning" &&
                          userRole === ROLE.BUYER && (
                            <IconButton
                              color="error"
                              onClick={() =>
                                handleDeleteProduct(product.itemId)
                              }
                            >
                              <DeleteIcon />
                            </IconButton>
                          )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Grid>
        {(order.Sendedproducts.length > 0 || sendedItems.length > 0) && (
          <Grid item xs={12}>
            <Paper sx={{ p: 3, mb: 2 }} elevation={0}>
              <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2 }}>
                {t("products.title")} {t("orders.actions.sent")}
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align={locale === LANG.EN ? "left" : "right"}
                      ></TableCell>
                      <TableCell
                        className="!font-bold !text-base"
                        align={locale === LANG.EN ? "left" : "right"}
                      >
                        {t("products.name")}
                      </TableCell>
                      <TableCell
                        className="!font-bold !text-base"
                        align={locale === LANG.EN ? "left" : "right"}
                      >
                        {t("orders.fields.supplier")}
                      </TableCell>
                      <TableCell
                        className="!font-bold !text-base"
                        align={locale === LANG.EN ? "left" : "right"}
                      >
                        {t("checkout.fields.quantity")}
                      </TableCell>
                      <TableCell
                        className="!font-bold !text-base"
                        align={locale === LANG.EN ? "left" : "right"}
                      >
                        {t("general.actions")}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {order.Sendedproducts.map(
                      (product) =>
                        product.quantity > 0 && (
                          <TableRow key={product.itemId}>
                            <TableCell
                              align={locale === LANG.EN ? "left" : "right"}
                            >
                              {product.image ? (
                                <img
                                  src={product.image}
                                  alt="item"
                                  style={{
                                    width: 70,
                                    height: 70,
                                    border: "1px solid #ccc",
                                    borderRadius: 15,
                                  }}
                                />
                              ) : (
                                "—"
                              )}
                            </TableCell>
                            <TableCell
                              align={locale === LANG.EN ? "left" : "right"}
                            >
                              {product.item}
                            </TableCell>
                            <TableCell
                              align={locale === LANG.EN ? "left" : "right"}
                            >
                              {product.company?.CompanyNr}
                            </TableCell>
                            <TableCell
                              align={locale === LANG.EN ? "left" : "right"}
                            >
                              {product.quantity}
                            </TableCell>
                            <TableCell
                              align={locale === LANG.EN ? "left" : "right"}
                            >
                              <IconButton
                                color="error"
                                onClick={() => handleRemoveFromSended(product)}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        )
                    )}
                    {sendedItems.map((item) => (
                      <TableRow key={item.itemId}>
                        <TableCell
                          align={locale === LANG.EN ? "left" : "right"}
                        >
                          {item.image ? (
                            <img
                              src={item.image}
                              alt="item"
                              style={{ width: 50, height: 50 }}
                            />
                          ) : (
                            "—"
                          )}
                        </TableCell>
                        <TableCell
                          align={locale === LANG.EN ? "left" : "right"}
                        >
                          {item.item}
                        </TableCell>
                        <TableCell
                          align={locale === LANG.EN ? "left" : "right"}
                        >
                          {item.company?.CompanyNr}
                        </TableCell>
                        <TableCell
                          align={locale === LANG.EN ? "left" : "right"}
                        >
                          {isFetchedSendedProduct(item) ? (
                            item.quantity
                          ) : (
                            <TextField
                              type="number"
                              value={item.quantity}
                              inputProps={{
                                min: 1,
                                max: order.products.find(
                                  (p) => p.itemId === item.itemId
                                )?.quantity,
                              }}
                              onChange={(e) =>
                                handleQuantitySChange(
                                  item,
                                  parseInt(e.target.value, 10)
                                )
                              }
                              size="small"
                            />
                          )}
                        </TableCell>
                        <TableCell
                          align={locale === LANG.EN ? "left" : "right"}
                        >
                          {!isFetchedSendedProduct(item) && (
                            <IconButton
                              color="error"
                              onClick={() => handleRemoveFromSended(item)}
                            >
                              <DeleteIcon />
                            </IconButton>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
            {order.invoices && order.invoices.length > 0 && (
              <Grid item xs={12}>
                <Paper sx={{ p: 3, mb: 2 }} elevation={0}>
                  <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
                    {t("invoices.title")}{" "}
                    {userRole === ROLE.BUYER
                      ? t("invoices.buyer")
                      : t("invoices.seller")}
                  </Typography>
                  <Divider sx={{ mb: 2 }} />
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell align="right">
                            {t("invoices.number")}
                          </TableCell>
                          <TableCell align="right">
                            {t("invoices.creationDate")}
                          </TableCell>
                          <TableCell align="right">
                            {t("invoices.downloadEn")}
                          </TableCell>
                          <TableCell align="right">
                            {t("invoices.downloadAr")}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {order.invoices.map((invoice, index) => (
                          <TableRow key={index}>
                            <TableCell align="right">
                              {invoice.fileName}
                            </TableCell>
                            <TableCell align="right">
                              {new Date(invoice.createdDate).toLocaleDateString(
                                "ar-SA"
                              )}
                            </TableCell>
                            <TableCell align="right">
                              <Button
                                variant="contained"
                                color="primary"
                                href={invoice.enVersion}
                                target="_blank"
                                sx={{
                                  backgroundColor: "#644980",
                                  "&:hover": {
                                    backgroundColor: "#533d68",
                                  },
                                }}
                              >
                                {t("invoices.downloadEn")}
                              </Button>
                            </TableCell>
                            <TableCell align="right">
                              <Button
                                variant="contained"
                                color="secondary"
                                href={invoice.arVersion}
                                target="_blank"
                                sx={{
                                  backgroundColor: "#644980",
                                  "&:hover": {
                                    backgroundColor: "#533d68",
                                  },
                                }}
                              >
                                {t("invoices.downloadAr")}
                              </Button>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>
              </Grid>
            )}
          </Grid>
        )}
      </Grid>
      {order.status === "Planning" && userRole === ROLE.BUYER && (
        <Box
          sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mb: 2 }}
        >
          <SaveOrderSubmitView
            isLoading={isOrderLoading}
            onClick={handleSaveOrder}
          />
          <SendOrderSubmitView
            isLoading={isOrderLoading}
            onClick={handleSendOrder}
          />
        </Box>
      )}
      {userRole === ROLE.SELLER && order.status === "Opened" && (
        <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
          <ConfirmOrderSubmitView
            isLoading={false}
            onClick={() => console.log("")}
          />
        </Box>
      )}
      {userRole === ROLE.SELLER && order.status === "Accepted" && (
        <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
          <SendOrderSubmitView
            isLoading={false}
            onClick={handleSaveSendedItems}
          />
        </Box>
      )}
      {userRole === ROLE.BUYER && order.status === "Sending" && (
        <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
          <ReceivedOrderSubmitView
            isLoading={false}
            onClick={() => {
              setIsConfirmReceivedPopupOpen(true);
            }}
          />
        </Box>
      )}
      {userRole === ROLE.SELLER && order.status === "Opened" && (
        <Dialog
          open={true}
          onClose={() => console.log("")}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>{t("actions.confirmprocess")}</DialogTitle>
          <DialogContent>
            <Typography>{t("general.ConfirmOrderbody")}</Typography>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              onClick={() => {
                handleConfirmAccept();
              }}
              sx={{
                mx: 1,
                borderColor: "#000",
                backgroundColor: "#000",
                "&:hover": {
                  borderColor: "#333",
                },
              }}
            >
              {t("orders.actions.acceptAction")}
            </Button>
            <Button
              color="error"
              onClick={() => {
                // setConfirmAction("cancel");
                handleConfirmCancel();
              }}
            >
              {t("actions.cancel")}
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {isTransformationPopupOpen && (
        <Dialog
          open={isTransformationPopupOpen}
          onClose={() => setIsTransformationPopupOpen(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>{t("payment.confirmTransfer")}</DialogTitle>
          <DialogContent>
            <Typography variant="body1" sx={{ mb: 2 }}>
              <strong>{t("orders.fields.totalPrice")}:</strong>{" "}
              {calculateTotalPrice(order?.products || []).toFixed(2)}{" "}
              {t("checkout.summary.currency")}
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" sx={{ mb: 2 }}>
              <strong>{t("payment.bankInfo")}:</strong>
              <br />
              <strong>{t("payment.accountName")}:</strong>{" "}
              {bankInfo.accountName}
              <br />
              <strong>{t("payment.accountNumber")}:</strong>{" "}
              {bankInfo.accountNumber}
              <br />
              <strong>{t("payment.iban")}:</strong> {bankInfo.iban}
              <br />
              <strong>{t("payment.bankName")}:</strong> {bankInfo.bankName}
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" sx={{ mb: 2 }}>
              <strong>{t("payment.uploadTransferImage")}:</strong>
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <FileUploader
                handleChange={handleFileUpload}
                name="file"
                types={["jpg", "png", "pdf"]}
                maxSize={5}
                label={t("general.DragOrClickToUpload")}
              />
              {uploadedFile && (
                <Typography variant="body2">
                  <UploadFile /> {uploadedFile.name}
                </Typography>
              )}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSendOrderWithTransformation}
              disabled={!uploadedFile || isSendingOrder}
              sx={{
                mx: 1,
                borderColor: "#000",
                backgroundColor: "#000",
                "&:hover": {
                  borderColor: "#333",
                },
              }}
            >
              {isSendingOrder ? t("actions.submitting") : t("actions.send")}
            </Button>
            <Button
              variant="outlined"
              color="error"
              onClick={() => setIsTransformationPopupOpen(false)}
            >
              {t("actions.cancel")}
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {isConfirmReceivedPopupOpen && (
        <Dialog
          open={isConfirmReceivedPopupOpen}
          onClose={() => setIsConfirmReceivedPopupOpen(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>{t("actions.confirmReceipt")}</DialogTitle>
          <DialogContent>
            <Typography>
              {t("alerts.confirmation.confirmReceiving")} {t("products.title")}؟
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              variant="contained"
              onClick={handleConfirmReceived}
              sx={{
                mx: 1,
                borderColor: "#000",
                backgroundColor: "#000",
                "&:hover": {
                  borderColor: "#333",
                },
              }}
            >
              {t("general.YesReceived")}
            </Button>
            <Button
              color="error"
              variant="outlined"
              onClick={() => setIsConfirmReceivedPopupOpen(false)}
            >
              {t("actions.cancel")}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </Box>
  );
};

export default OrderPage;
